







































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ScoreService } from "@/services/score-service";
import { Score } from '@/model/score';
import { signIn, signOut, signedIn, authManager} from '../utils/login';
import { User } from 'oidc-client';
import * as Constants from '@/utils/constants';
import DatePicker from "vue2-datepicker";

@Component({
    components: {
        DatePicker
    }
})
export default class AddScore extends Vue {
    // data
    error: any = null;
    loading: boolean = false;
    name: string = '';
    userCode: string = "";
    points: number = 0;
    description: string = '';
    scoreDate: Date = new Date();
    dismissSecs: number = 10;
    dismissCountDown: number = 0;
    showDismissibleAlert: boolean = false;
    score: Score = {
        id: '',
        userCode: '',
        points: 0,
        description: '',
        scoreDate: new Date()
    }

    isSignedIn = false;
    isAdmin = false;
    accessToken = "";

    reportStartDate: Date = this.initReportStartDate();
    reportEndDate: Date = new Date();

    scoreService: ScoreService = new ScoreService();

    // data for user
    token: string = '';

    @Prop()
    user: any;

    created() {
        if (this.user) {
            this.loadUserData(this.user);
        }
    }

    login() {
        signIn();
    }

    logout() {
        signOut();
    }

    private loadUserData(userObj: User) {
        if (userObj) { 
            this.isSignedIn = true;
            this.isAdmin = this.user 
                        ? this.user.profile.roles.indexOf(Constants.ADMIN_ROLE) > -1
                        : false;
            this.accessToken = this.user.access_token
        }
    }

    @Watch('user')
    onUserChanged(newUser: User) {
        this.loadUserData(newUser);

    }
    
    // computed
    get isValidForm () {
        return this.userCode && this.points != 0;
    }

    // methods
    addScore() {
        console.log("Adding score to user", this.userCode);
        this.score = {
            id: '',
            userCode: this.userCode, 
            points: this.points,
            description: this.description,
            scoreDate: new Date()
        }
        this.scoreService.addScore(this.score, this.accessToken).then((response: any) => {
            console.log(response);
            if (response.status === 201) {
                this.showDismissibleAlert = true;
                this.dismissCountDown = 300;
                this.points = 0;
                this.userCode = '';
            } else {
                console.log("Errore!")
                this.showDismissibleAlert = false;
            }
        })
    }

    countDownChanged(dismissCountDown: number) {
      this.dismissCountDown = dismissCountDown;
    }

    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    }

    downloadScoreReport() {
        if (!this.reportStartDate) {
            alert('Inserisci una data di inizio report');
            return;
        }
        this.scoreService.downloadlScoreList(this.token, this.reportStartDate, this.reportEndDate);
    }

    private initReportStartDate(): Date {
        const d: Date = new Date();
        const lastMonth = d.getMonth() - 1;
        d.setMonth(lastMonth);
        return d;
    }
}

